import { useTranslation } from 'react-i18next';

export const useDocumentTitles = () => {
  const { t } = useTranslation('common');

  return {
    cookies: t('common/documentTitle.title.cookies'),
    signup: t('common/documentTitle.title.signUp'),
    sapConcur: t('common/documentTitle.title.sapConcur'),
    safetyCheck: t('common/documentTitle.title.safetyCheck'),
    chat: t('common/documentTitle.title.chat'),
  };
};
